import React 		from 'react'
import classnames 	from 'classnames'
import {
	get
} from 'lodash'

import Icon 		from '../icon'

export default (props) => {
	const {
        post,
        showIcon,
        className
	} = props

	if(!post){ return null }

	const videoOrImage = get(post, 'acf.main.display') === 'video' ? 'video' : 'image'
    const readingTime = videoOrImage === 'video' ? (get(post, 'acf.main.video_length') ? parseFloat(get(post, 'acf.main.video_length')) : null) : get(post, 'meta.endomag_reading_time')

    const hasReadingTime = isFinite(readingTime) && readingTime > 0
    const readingTimeString = videoOrImage === 'video' ? 'watch' : 'read'
    
    return !hasReadingTime && !showIcon ? null : <div className={ classnames('storyLength', className) }>
            { showIcon ? <Icon
                icon={ videoOrImage === 'video' ? 'play' : 'read' }
                outlined={ true }
                /> : null }
            <span>{ hasReadingTime ? `${ readingTime } minute ` : `` }{ hasReadingTime ? readingTimeString : readingTimeString.slice(0, 1).toUpperCase() + readingTimeString.slice(1) }</span>
        </div>
}